import styled from 'styled-components';
import React from 'react';
import { slideIn } from 'styles/animation';
import { colors } from '@alixpartners/ui-components';

export const AbortPopup = styled.div`
	pointer-events: none;
`;
export const MultiSelectWrapper = styled.span`
	> div {
		> div {
			border-radius: 0;
		}
	}
`;

export const ModalBody = styled.div`
	text-align: center;
	margin: 2px;
`;

export const LoaderWrapper = styled.div`
	width: 100%;
	text-align: center;
	padding: 15% 0;
`;

export const Wrapper = styled.section`
	display: flex;
	flex-direction: column;
	background-color: ${colors.white};
	animation-name: ${slideIn};
	animation-duration: 600ms;
	animation-timing-function: cubic-bezier(0.23, 1, 0.32, 1);
`;

export const Container = styled.div`
	padding: 0 3%;
	height: 425px;
	overflow-y: auto;
	&::-webkit-scrollbar {
		width: 5px;
	}

	&::-webkit-scrollbar-thumb:vertical {
		background-color: #888;
		border-radius: 7px;
	}

	&::-webkit-scrollbar-track:vertical {
		background-color: #f1f1f1;
		border-radius: 5px;
	}

	/* For Firefox */
	scrollbar-width: thin;
	scrollbar-color: #888 #f1f1f1;

	/* Additional styling for the track in Firefox */
	& {
		scrollbar-track-color: #f1f1f1;
	}
`;

export const WidgetFilterDiv = styled.div`
	padding: 3% 0;
	> p {
		font-size: 12px;
		margin-bottom: 10px;
	}
	> div {
		display: flex;
	}
`;

export const SpendWrapper = styled.div`
	max-width: 580px;
	display: flex;
	flex-direction:column;
	flex:2;
	align-items: center;
	width: 330px;
	border: 1px solid ${colors.grey300}
	padding:2px
	>span {
		font-size: 9px;
	}
	margin:0 0 7px 7px;
`;

export const InputWrapper = styled.div`
	width: 90px;
	min-width: 90px;

	input {
		min-width: 90px;
	}
`;
export const SaveWrapper = styled.div`
	position: sticky;
	bottom: 0;
	border-top: 1px solid grey;
	height: max-content;
	color: white;
	padding: 5px;
`;
export const RangeWrapper = styled.div`
	align-items: center;
	width: 100%;
	padding: 0 10px;

	.rc-slider {
		.rc-slider-track {
			background-color: ${colors.green1};
			height: 3px;
		}

		.rc-slider-handle {
			background-color: ${colors.green1};
			border-color: ${colors.green1};
			opacity: 1;
			width: 10px;
			height: 10px;
			margin-top: -4px;
			&:focus {
				box-shadow: 0 0 0 3px rgb(92, 179, 53, 0.4);
				border-color: ${colors.green1};
			}

			&.rc-slider-handle-dragging {
				box-shadow: 0 0 0 6px rgb(92, 179, 53, 0.4);
			}
		}
	}
`;
export const WidgetData = styled(({ children, ...props }) => (
	<table {...props}>
		<tbody>{children}</tbody>
	</table>
))``;

export const WidgetSettingsRow = styled.tr``;
export const WidgetSettingsLabel = styled.td`
	color: ${colors.grey500};
	font-size: 14px;
	line-height: 30px;
	text-transform: uppercase;
	font-weight: normal;
	padding: 1% 2% 1% 0;
	width: 100%;
`;
export const WidgetSettingsValue = styled.td`
	color: ${colors.black};
	font-size: 16px;
	font-weight: 500;
	line-height: 32px;
	display: flex;
	align-items: flex-start;
	padding: 8px 0;
`;
export const TooltipContent = styled.div`
	text-align: left;
	padding: 4px;

	span {
		font-weight: bold;
	}
`;
